import React from 'react';
import { Paper, createStyles, makeStyles, Theme } from '@material-ui/core';

interface Props {
    children?: React.ReactNode;
}

function PageSection(props: Props) {

    const classes = useStyles();

    return (
        <Paper className={classes.paper}>
            {props.children}
        </Paper>

    );
}

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        paper: {
            marginBottom: theme.spacing(4),
        },
    })
);

export default PageSection;